import GetDeviceListDummyData from "../../../dummy/GetDeviceListDummyData.json";
import GetDeviceStatusDummyData from "../../../dummy/GetDeviceStatusDummyData.json";
import GetDeviceDetailDummyData from "../../../dummy/GetDeviceDetailDummyData.json";
import GetDeviceDetailHistoryDummyData from "../../../dummy/GetDeviceDetailHistoryDummyData.json";
import GetDeviceErrorListDummyData from "../../../dummy/GetDeviceErrorListDummyData.json";
import GetDeviceSettingsDummyData from "../../../dummy/GetDeviceSettingsDummyData.json";
import SaveDeviceSettingsDummyData from "../../../dummy/SaveDeviceSettingsDummyData.json";
import GetSubDeviceDummyData from "../../../dummy/GetSubDeviceDummyData.json";
import GetSubDeviceByStoreDummyData from "../../../dummy/GetSubDeviceByStoreDummyData.json";
import SuccessResponse from "../dto/common/SuccessResponse";
import DeviceDto from "../dto/device/DeviceDto";
import DeviceStatusDto from "../dto/device/DeviceStatusDto";
import DeviceDetailDto from "../dto/device/DeviceDetailDto";
import DeviceHistoryResDto from "../dto/device/DeviceHistoryResDto";
import DeviceErrorDto from "../dto/device/DeviceErrorDto";
import DeviceSettingsDto from "../dto/device/DeviceSettingsDto";
import SubDeviceDto from "../dto/device/SubDeviceDto";

class FakeDeviceApi {
    getDeviceList = async (): Promise<SuccessResponse<DeviceDto[]>> => {
        return GetDeviceListDummyData;
    };

    getDeviceStatus = async (): Promise<SuccessResponse<DeviceStatusDto>> => {
        return GetDeviceStatusDummyData;
    };

    getDeviceDetails = async (): Promise<SuccessResponse<DeviceDetailDto>> => {
        return GetDeviceDetailDummyData;
    };

    getDeviceDetailsHistory = async (): Promise<SuccessResponse<DeviceHistoryResDto>> => {
        return GetDeviceDetailHistoryDummyData;
    };

    getDeviceErrorList = async (): Promise<SuccessResponse<DeviceErrorDto[]>> => {
        return GetDeviceErrorListDummyData;
    };

    saveDeviceSettings = async (): Promise<SuccessResponse<{}>> => {
        return SaveDeviceSettingsDummyData;
    };

    getDeviceSettings = async (): Promise<SuccessResponse<DeviceSettingsDto[]>> => {
        return GetDeviceSettingsDummyData;
    };

    getSubDevice = async (): Promise<SuccessResponse<SubDeviceDto>> => {
        return GetSubDeviceDummyData;
    };

    getSubDeviceByStore = async (): Promise<SuccessResponse<SubDeviceDto[]>> => {
        return GetSubDeviceByStoreDummyData;
    };
}

export default FakeDeviceApi;
